"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InViewAnimation = void 0;

var react_1 = __importStar(require("react"));

var components_utils_1 = require("@conte-ltd/components-utils");

var animation_1 = require("./animation");

var react_intersection_observer_1 = require("react-intersection-observer");

var use_animation_controller_1 = require("./use-animation-controller");

function _InViewAnimation(props, fwRef) {
  var children = props.children,
      threshold = props.threshold,
      delay = props.delay,
      trackVisibility = props.trackVisibility,
      rootMargin = props.rootMargin,
      root = props.root,
      triggerOnce = props.triggerOnce,
      skip = props.skip,
      initialInView = props.initialInView,
      options = props.options,
      other = __rest(props, ["children", "threshold", "delay", "trackVisibility", "rootMargin", "root", "triggerOnce", "skip", "initialInView", "options"]);

  var _a = (0, react_intersection_observer_1.useInView)({
    threshold: threshold,
    delay: delay,
    trackVisibility: trackVisibility,
    rootMargin: rootMargin,
    root: root,
    triggerOnce: triggerOnce,
    skip: skip,
    initialInView: initialInView
  }),
      inViewRef = _a.ref,
      inView = _a.inView;

  var _b = (0, use_animation_controller_1.useAnimationController)(),
      animationRef = _b.ref,
      play = _b.play,
      updatePlaybackRate = _b.updatePlaybackRate;

  (0, react_1.useEffect)(function () {
    var rate = inView ? 1 : -1;
    updatePlaybackRate(rate);
    play();
  }, [inView]);
  return react_1.default.createElement(animation_1.Animation, __assign({
    options: __assign({
      duration: 500
    }, options),
    ref: (0, components_utils_1.mergeRefs)([fwRef, animationRef])
  }, other), function (_a) {
    var ref = _a.ref;
    return (0, components_utils_1.runIfFunction)(children, {
      ref: (0, components_utils_1.mergeRefs)([inViewRef, ref])
    });
  });
}

exports.InViewAnimation = (0, react_1.forwardRef)(_InViewAnimation);